import { useInstance } from 'react-ioc';
import { SchoolStore } from 'stores';

export function useSchool() {
    return useInstance(SchoolStore).school;
}